import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import TransportHero from './components/TransportHero';
import MarketplaceSection from './components/MarketplaceSection';
import RouteMatching from './components/RouteMatching';
import TrustCompliance from './components/TrustCompliance';
import PricingSection from './components/PricingSection';
import TransportCTABand from './components/TransportCTABand';

export default function TransportPage() {
  return (
    <>
      <Navbar />
      <main>
        <TransportHero />
        <MarketplaceSection />
        <RouteMatching />
        <TrustCompliance />
        <PricingSection />
        <TransportCTABand />
      </main>
      <Footer />
    </>
  );
}